import { FunctionComponent } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";

export type InfoDialogProps = {
    isOpened: boolean,
    onClose: () => void,
}

export const InfoDialog: FunctionComponent<InfoDialogProps> = ({ isOpened, onClose }) => (
    <Dialog
        open={isOpened}
        onClose={onClose}
    >
        <DialogTitle >
            O co jde?
        </DialogTitle>
        <DialogContent>
            <DialogContentText sx={{ color: "var(--dialog-text)" }}>
                Máme rádi sport, data a technologie. Již několik let soutěžíme v celofiremní výzvě, kdo nasbírá během roku nejvíc kilometrů/minut.
                Evidujeme, kolik naběháme, uplaveme, ujedeme na kole, na bruslích nebo kolik minut strávíme jinou sportovní aktivitou.
                Na konci roku nasportované kilometry a minuty z celé firmy sečteme, přetavíme na Kč a výslednou sumou obdarujeme někoho v našem okolí.
                <br/>
                <br/>
                Morokilometry evidujeme v těchto kategoriích:
                <br/>
                <br/>
                <ul>
                    <li>Kolo | 1 km ~ 1 Kč | Strava: Ride, VirtualRide, Handcycle</li>
                    <li>Běh | 1 km ~ 1 Kč | Strava: Run, VirtualRun, NordicSki</li>
                    <li>Chůze | 1 km ~ 1 Kč | Strava: Walk, Hike</li>
                    <li>Plavání | 1 km ~ 1 Kč | Strava: Swim</li>
                    <li>Brusle | 1 km ~ 1 Kč | Strava: InlineSkate, IceSkate</li>
                    <li>Fitness | 10 min ~ 1 Kč | Strava: Workout, Yoga, WeightTraining, Crossfit</li>
                </ul>
                <br/>
                Hosté mimo MoroSystems mají u jména ikonu podání ruky. Nemají pořadí, ale jejich km se počítají do daru.
                <br/>
                <br/>
                Morokilometry běží každý rok od začátku února do konce listopadu.
                <br/>
                <br/>
                <a
                    href="https://www.morosystems.cz/"
                    target="_blank"
                    rel="noreferrer"
                    style={{ textDecoration: "underline" }}
                >
                    www.morosystems.cz
                </a>
            </DialogContentText>
        </DialogContent>
        <DialogActions>
            <Button onClick={onClose}>
                OK
            </Button>
        </DialogActions>
    </Dialog>
);
